import { Avatar, Tab } from '@mui/material'
import { Tabs } from '@mui/material'

import { SidebarMode } from './SidebarContext'
import useSidebar from './useSidebar'
const SidebarTabs = () => {
  const { mode, setMode, selectedAssistant } = useSidebar()

  return (
    <Tabs
      value={mode}
      onChange={(_, value) => setMode(value)}
      className="sidebar-tabs"
    >
      <Tab
        label={selectedAssistant?.firstName || 'Day.ai Assistant'}
        value={SidebarMode.THREADS}
        icon={
          <Avatar
            src={selectedAssistant?.photoUrl}
            sx={{ height: '16px', width: '16px' }}
          />
        }
        iconPosition="start"
      />
      <Tab
        label="Detail"
        value={SidebarMode.VIEW}
      />
      <Tab
        label="Related"
        value={SidebarMode.RELATED}
      />
    </Tabs>
  )
}

export default SidebarTabs
